import { FlowNodeTypes } from '../../types'
import { isAiConversationNode } from '../../utils/ai-agent-utils'
import type { NodeExecutedEvent } from '../types'
import { AINodeAnalysis } from './ai-nodes'
import { FlowCompletionAnalysis } from './flow-completion'
import { NonAINodeAnalysis } from './non-ai-nodes'

interface AnalysisRendererProps {
  node: NodeExecutedEvent
}

export const AnalysisRenderer = ({ node }: AnalysisRendererProps) => {
  if (!node.current_node_type) return null
  // Handle flow completion (Test End)
  if (
    node.current_node === 'Test End' &&
    node.current_node_type === FlowNodeTypes.end_conversation
  ) {
    return <FlowCompletionAnalysis node={node} />
  }

  // Handle AI nodes (ai_agent_call, ai_agent_v2, etc.)
  if (
    isAiConversationNode(node.current_node_type) ||
    node.current_node_type === FlowNodeTypes.ai_agent_call
  ) {
    return <AINodeAnalysis node={node} />
  }

  // Handle all other node types
  return <NonAINodeAnalysis node={node} />
}
